import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function ForwardListIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M2 14v-1.05c0-2.52 0-3.78.49-4.743A4.5 4.5 0 0 1 4.457 6.24c.963-.49 2.223-.49 4.743-.49H14m0 0L10.25 9.5M14 5.75 10.25 2" /></svg>
  );
}

export default ForwardListIcon;
